import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ExportItems, TypeFormats } from '../../../../../../../shared/types/exportItem';
import { ExportFileService } from 'src/app/gamification/command-center/services/export-file.service';
import { ChartConfiguration } from "chart.js";
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-budget-export-button',
  templateUrl: './budget-export-button.component.html',
  styleUrls: ['./budget-export-button.component.scss']
})

export class BudgetExportButtonComponent implements AfterViewInit, OnInit, OnChanges {

  @Input()
  chartData: any;
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;

  chartConfig = null;
  fileName = '';
  public localizationDic: Map<string, string> = new Map();

  items: ExportItems = {
    png: {
      getData: (format) => this.exportHistoryChart(format)
    }
  };


  backgroundcolor = {
    id: 'custom_canvas_background_color',
    beforeDraw: (chart) => {
      const ctx = chart.canvas.getContext('2d');
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#F5F8FA';
      ctx.fillRect(0, 0, chart.canvas.width, chart.canvas.height);
      ctx.restore();
    }
  }

  noData = {
    id: 'custom_canvas_background_color',
    afterDraw: (chart) => {
      const { datasets } = chart.data;
      let hasData = false;

      for (let dataset of datasets) {
        if (dataset.data.length > 0 && dataset.data.some(item => item !== 0)) {
          hasData = true;
          break;
        }
      }
      if (!hasData) {
        const { chartArea: { left, top, right, bottom }, ctx } = chart;
        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;
        //This is only to simulate lines in the image. 
        chart.clear();
        ctx.save();

        ctx.fillStyle = 'white';
        ctx.fillRect(left, top, right - left, bottom - top);

        ctx.beginPath();
        ctx.strokeStyle = '#ddd';
        ctx.lineWidth = 1;

        for (let y = top; y <= bottom; y += (bottom - top) / 10) {
          ctx.moveTo(left, y);
          ctx.lineTo(right, y);
        }

        for (let x = left; x <= right; x += (right - left) / 10) {
          ctx.moveTo(x, top);
          ctx.lineTo(x, bottom);
        }
        ctx.stroke();

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#000';
        ctx.font = '12px Arial';

        ctx.fillText(this.getLocalizationString("Chart_No_Data", "No data available"), centerX, centerY);

        ctx.restore();
      }
    }
  }
  constructor(
    private cvLocalizationService: CVLocalizationService,
    private exportFile: ExportFileService,
  ) {
    this.canvasRef = new ElementRef(null);
  }

  ngOnInit(): void {
    this.initAsync();
  }

  ngAfterViewInit(): void {
    this.canvasRef = this.canvasRef || new ElementRef(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chartData && !changes.chartData.firstChange) {
      this.chartConfig.data = this.chartData;
    }
  }

  async initAsync() {
    this.localizationDic = await this.cvLocalizationService.GetSection("Budget");
  }

  async exportHistoryChart(format: TypeFormats): Promise<string> {
    const body = {
      format
    }

    this.fileName = this.getLocalizationString("Budget_History", "Budget History") + ' ';

    return this.exportPNG().then(async canvas => {
      const imageDataUrl = canvas.toDataURL('image/png');
      await this.exportFile.exportReport("/api/v1/gamification/budget-history-export", body);
      return imageDataUrl;
    });
  }

  exportPNG(): Promise<HTMLCanvasElement> {
    //It is necessary to draw the chart for downloading.
    //If it exists within the same component, it is only taken from the state of the chart.
    return new Promise((resolve, reject) => {
      this.chartConfig = {
        type: 'bar',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scaleShowVerticalLines: false,
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: this.chartData.dateRange == 'Year' ? this.getLocalizationString("Months_of_the_Year", "Months of the Year") : this.getLocalizationString("Days_of_the_Month", "Days of the Month")
              }
            },
            y: {
              display: true,
              title: {
                display: true,
                text: this.getLocalizationString("Amount_Coins_Awarded", "Amount of Coins Awarded")
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                fontColor: 'black',
                fontSize: 12,
              }
            }
          }
        },
        plugins: [this.backgroundcolor, this.noData],

      } as ChartConfiguration;

      setTimeout(() => {
        const canvas = this.canvasRef.nativeElement;
        resolve(canvas);
      }, 800);
    });
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationDic && this.localizationDic.has(key))
      return this.localizationDic.get(key);
    return defaultValue;
  }
}
